const defaultTheme = {
  primary: process.env.VUE_APP_PRIMARY_COLOR || "#3F51B5",
  secondary: process.env.VUE_APP_PRIMARY_COLOR || "#f03b00",
  accent: "#E86413",
  error: "#f44336",
  warning: "#ff9800",
  info: "#03a9f4",
  success: process.env.VUE_APP_PRIMARY_COLOR || "#4caf50",
  anchor: "red",
  white: "#fff",
  yellowTheme: "fbbb14",
};
// #ededed
// #f5f5f5
export default defaultTheme;
